import apiClient from '@/shared/api/client'

export interface YarnRecipe {
  id: string
  plant_id: string
  recipe_code: string
  recipe_name: string
  // Sprint 0066 — standardised name. Was `yarn_count_ne`, now `count_ne`
  // to match every other table in the system.
  count_ne: number | string
  yarn_description?: string
  end_use: string
  process_type: string
  count_master_id?: string
  target_mic?: number | string
  target_mic_min?: number | string
  target_mic_max?: number | string
  target_uhml_mm?: number | string
  target_uhml_min?: number | string
  target_uhml_max?: number | string
  target_strength?: number | string
  target_strength_min?: number | string
  target_uniformity?: number | string
  target_uniformity_min?: number | string
  target_trash_max?: number | string
  target_sfc_max?: number | string
  target_rd?: number | string
  target_rd_min?: number | string
  target_rd_max?: number | string
  target_plus_b?: number | string
  target_plus_b_min?: number | string
  target_plus_b_max?: number | string
  max_lot_pct: number | string
  min_lot_pct: number | string
  max_laydown_bales: number
  max_cost_per_kg?: number | string
  max_soft_waste_pct: number | string
  // Sprint 0068 — hard diversity rules (enforced, not advisory)
  max_lots_per_supplier?: number
  max_bales_per_lot?: number
  status: string
  revision_no: number
  effective_from?: string
  effective_to?: string
  approved_at?: string
  notes?: string
  is_active: boolean
  created_at: string
}

export interface BSIWeights {
  id: string
  plant_id: string
  count_suitability_pct: number | string
  strength_length_pct: number | string
  realization_potential_pct: number | string
  color_consistency_pct: number | string
  processing_stability_pct: number | string
  cost_advantage_pct: number | string
  is_active: boolean
  updated_at: string
}

export const recipeApi = {
  list: (params?: Record<string, unknown>) => apiClient.get<YarnRecipe[]>('/yarn-recipes', { params }).then(r => r.data),
  get: (id: string) => apiClient.get<YarnRecipe>(`/yarn-recipes/${id}`).then(r => r.data),
  create: (data: Record<string, unknown>) => apiClient.post<YarnRecipe>('/yarn-recipes', data).then(r => r.data),
  update: (id: string, data: Record<string, unknown>) => apiClient.patch<YarnRecipe>(`/yarn-recipes/${id}`, data).then(r => r.data),
  submit: (id: string) => apiClient.post<YarnRecipe>(`/yarn-recipes/${id}/submit`).then(r => r.data),
  approve: (id: string, data: Record<string, unknown>) =>
    apiClient.post<YarnRecipe>(`/yarn-recipes/${id}/approve`, data).then(r => r.data),
  archive: (id: string) => apiClient.post<YarnRecipe>(`/yarn-recipes/${id}/archive`).then(r => r.data),
}

export const bsiWeightsApi = {
  get: (plant_id: string) =>
    apiClient.get<BSIWeights>(`/bsi-weights/${plant_id}`).then(r => r.data),
  update: (plant_id: string, data: Partial<BSIWeights>) =>
    apiClient.patch<BSIWeights>(`/bsi-weights/${plant_id}`, data).then(r => r.data),
  computeForBale: (bale_id: string) =>
    apiClient.post(`/bsi/compute/${bale_id}`).then(r => r.data),
  recomputePlant: (plant_id: string, only_missing = true) =>
    apiClient.post(`/bsi/recompute-plant/${plant_id}`, null, {
      params: { only_missing },
    }).then(r => r.data),
}
